<div class="box min-h-25 is-justified-center empty-cart-item">
    <div class="has-text-centered">
        <div class="columns is-multiline is-marginless">
            <div class="column is-12 is-flex">
                <p class="title is-level-5 has-text-weight-bold info-line">{{ itemLabel }}</p>
            </div>
            <div class="column is-12">
                <span class="icon is-medium" [ngClass]="textColor">
                    <i [ngClass]="itemIcon"></i>
                </span>
            </div>

            <div class="column is-12">
                <a [href]="wallUrl" [attr.aria-label]="ctaAriaLabel" class="button is-primary">Choisir</a>
            </div>
        </div>
    </div>
</div>
